import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from "@angular/core";
import { Subject } from "rxjs";
import { MultiSelectPipe } from "@app/shared/pipes/multi-select.pipe";
import * as _ from "lodash";

@Component({
  selector: "app-custom-mutli-select-dropdown",
  templateUrl: "./custom-mutli-select-dropdown.component.html",
  styleUrls: ["./custom-mutli-select-dropdown.component.css"]
})
export class CustomMutliSelectDropdownComponent implements OnInit, OnDestroy {
  @Input()
  set listItems(list) {
    this.completeList = list;
    this.suggestions = list;
  }
  @Input()
  set placeholderText(value) {
    this.placeholder = value;
  }
  @Input()
  set selectedDomain(domain) {
    if (domain) {
      this.selectSuggestion(domain);
    }
  }

  @Output() selectionDomainEvent = new EventEmitter<Array<String>>();
  suggestions: any = [];
  completeList: any = [];
  placeholder: string = "Choose";
  userSelectsString = "";
  userSelects = [];
  show: boolean = false;
  searchText: string;
  results: any =[];
  selectedDomains = [];
  domainSelected: any;
  constructor(private multiSelectPipe: MultiSelectPipe) {}
  ngOnDestroy(): void {}

  ngOnInit(): void {}

  suggest() {
    this.show = true;
    this.searchText = "";
  }

  selectSuggestion(data) {
    let findIndex = -1;
    if (this.userSelects.length > 0) {
      findIndex = this.userSelects.findIndex(x => x.value.id === data.value.id);
    }
    if (findIndex > -1) {
      this.deleteSelects(data);
    } else {
      this.userSelects.push(data);
      this.closeComponent();
    }
  }

  deleteSelects(s) {
    this.userSelects = this.userSelects.filter(item => item.value.id !== s.value.id);
    this.closeComponent();
  }

  selectAll(event) {
    if (event.target.checked) {
      this.userSelects = this.completeList;
    } else {
      this.userSelects = [];
    }
    this.closeComponent();
  }

  closeComponent() {
    this.results = [];
    this.userSelects.forEach(item => {
      this.results.push(item.value);
    });
    this.selectedDomains = _.map(this.userSelects, 'label');
    this.selectionDomainEvent.emit(this.results);
  }
  searchDomain(value) {
    this.searchText = value || null;
  }

  isSelected(data){
    return this.userSelects.findIndex(item => item.value.id === data.value.id) > -1
    ? true
    : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/custom-mutli-select-dropdown/custom-mutli-select-dropdown.component.ts